// extracted by mini-css-extract-plugin
module.exports = {"navArrow":"yN","navArrowSvg":"yO","wrapper":"yP","reverse":"yQ"};